import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const updateScenario = api(async function updateScenario({ id, name, rateCardId, ruleSetId, ruleSetIds }) {
    return mutate(
        gql`
            mutation UpdateScenario(
                $id: String!
                $name: String
                $rateCardId: String
                $ruleSetId: String
                $ruleSetIds: [String]
            ) {
                updateScenario(
                    id: $id
                    name: $name
                    rateCardId: $rateCardId
                    ruleSetId: $ruleSetId
                    ruleSetIds: $ruleSetIds
                )
            }
        `,
        { id, name, rateCardId, ruleSetId, ruleSetIds },
        { returns: "updateScenario" }
    )
})
